// Vertical Tabs Custom Slider Using Flickity JS & Theme resize
// Custom JS UI https://codepen.io/desandro/pen/emVRjv
// Multiple Flickity Carousels https://codepen.io/desandro/details/mmKKyL/60e8036ccbe34f8375d7b1021995dad8

var verticalTabContainers = document.querySelectorAll('.vertical-tabs-container');

for ( var i=0; i < verticalTabContainers.length; i++ ) {
  var container = verticalTabContainers[i];
  initVerticalTabContainer( container );
}

function initVerticalTabContainer( container ) {

  // external js: flickity.pkgd.js
  var utils = window.fizzyUIUtils;
  
  var verticalTabs = container.querySelector('.vertical-tabs-content');

  // Already initialized (e.g. size guide modal reopened): just re-measure.
  // Flickity measures 0 while hidden, so adaptiveHeight collapses the viewport.
  var existingFlkty = Flickity.data( verticalTabs );
  if ( existingFlkty ) {
    existingFlkty.resize();
    return existingFlkty;
  }

  var flkty = new Flickity( verticalTabs, {
    dragThreshold: 10,
    pageDots: false, 
    prevNextButtons: false,
    adaptiveHeight: true,
    wrapAround: true,
    cellAlign: 'left'
  });
  // elements
  var cellsButtonGroup = container.querySelector('.vertical-tabs');
  var cellsButtons = utils.makeArray( cellsButtonGroup.children );
  
  // update buttons on select
  flkty.on( 'select', function() {
    var previousSelectedButton = cellsButtonGroup.querySelector('.is-selected');
    var selectedButton = cellsButtonGroup.children[ flkty.selectedIndex ];
    previousSelectedButton.classList.remove('is-selected');
    selectedButton.classList.add('is-selected');
  });
  
  // cell select
  cellsButtonGroup.addEventListener( 'click', function( event ) {
    if ( !matchesSelector( event.target, '.tab-button' ) ) {
      return;
    }
    var index = cellsButtons.indexOf( event.target );
    flkty.select( index );
  });
  // previous
  // var previousButton = container.querySelector('.button--previous');
  // previousButton.addEventListener( 'click', function() {
  //   flkty.previous();
  // });
  // next
  // var nextButton = container.querySelector('.button--next');
  // nextButton.addEventListener( 'click', function() {
  //   flkty.next();
  // });
  
  // Added to fix resize from mobile to desktop
  window.on('resize', theme.utils.debounce(300, function() {
    // console.log('Window Resized');
    // Skip while hidden (closed modal) to avoid measuring a 0 height
    if (!verticalTabs.offsetWidth) return;
    flkty.resize();
  }.bind(this)));

  // Toggles EUR & US Size Charts in the Mobile Tab Content
  // Check if US size elements exist
  if (document.querySelectorAll('.contry_size .us_size').length) {
    document.addEventListener('click', function(e) {
      if (e.target.matches('.contry_size .us_size')) {
        document.querySelector('.mob_html .us_size_chart').classList.add('active');
        document.querySelector('.mob_html .eur_size_chart').classList.remove('active');
        document.querySelector('.contry_size .us_size').classList.add('selected');
        document.querySelector('.contry_size .eur_size').classList.remove('selected');
      }
    });
  }
  
  // Check if EUR size elements exist
  if (document.querySelectorAll('.contry_size .eur_size').length) {
    document.addEventListener('click', function(e) {
      if (e.target.matches('.contry_size .eur_size')) {
        document.querySelector('.mob_html .us_size_chart').classList.remove('active');
        document.querySelector('.mob_html .eur_size_chart').classList.add('active');
        document.querySelector('.contry_size .us_size').classList.remove('selected');
        document.querySelector('.contry_size .eur_size').classList.add('selected');
      }
    });
  }

  return flkty;
}

// Carousel Columns
var carouselColumns = document.querySelectorAll('.carousel-columns');

for ( var i=0; i < carouselColumns.length; i++ ) {
  var carouselColumn = carouselColumns[i];
  initCarouselColumn( carouselColumn );
}

function initCarouselColumn( container ) {

  var verticalTabs = container.querySelector('.carousel-container');
  var flkty = new Flickity( verticalTabs, {
    dragThreshold: 10,
    pageDots: false,
    cellAlign: 'left'
    // wrapAround: true
  });
  // Equalize cell heights to tallest
  function equalizeCarouselCells() {
    var cells = container.querySelectorAll('.carousel-cell');
    if (!cells.length) return;
    // reset first
    cells.forEach(function(cell){ cell.style.minHeight = ''; });
    // measure
    var max = 0;
    cells.forEach(function(cell){
      var h = cell.getBoundingClientRect().height;
      if (h > max) max = h;
    });
    // apply
    if (max > 0) {
      cells.forEach(function(cell){ cell.style.minHeight = max + 'px'; });
    }
  }
  // Mousewheel scroll support with gesture debounce
  let wheelAccum = 0;
  let wheelAnimating = false;
  let lastWheelFrame;

  verticalTabs.addEventListener('wheel', (e) => {
    if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
    e.preventDefault();
    if (!flkty || wheelAnimating) return;

    wheelAccum += e.deltaX;

    if (!lastWheelFrame) {
      lastWheelFrame = requestAnimationFrame(() => {
        if (wheelAccum > 20) {
          flkty.next(true, false);
          wheelAnimating = true;
        } else if (wheelAccum < -20) {
          flkty.previous(true, false);
          wheelAnimating = true;
        }

        wheelAccum = 0;
        lastWheelFrame = null;
      });
    }
  }, { passive: false });

  flkty.on('settle', () => {
    wheelAnimating = false;
  });
  // Run equalize after init and when Flickity is ready/resize
  flkty.on('ready', equalizeCarouselCells);
  flkty.on('select', equalizeCarouselCells);
  // If imagesLoaded is available, wait for images to load
  if (window.imagesLoaded) {
    imagesLoaded(verticalTabs, equalizeCarouselCells);
  } else {
    // Fallback: run after window load
    if (document.readyState === 'complete') {
      equalizeCarouselCells();
    } else {
      window.addEventListener('load', equalizeCarouselCells);
    }
  }
  
  // Added to fix resize from mobile to desktop
  window.on('resize', theme.utils.debounce(300, function() {
    // console.log('Window Resized');
    flkty.resize();
    equalizeCarouselCells();
  }.bind(this)));  
  
}  

// Add some functions and reinits for when tooltip:open
// This is mostly used on the size_chart tooltip which pulls page content
// document.addEventListener('tooltip:open', function() {
  
  // console.log('tooltip:open');
  
// }); 

// Added to fix images failing to animate in after scrolling
let scrollRef = 0;

function handleScrollResize() {
  // Increase value up to 10, then refresh AOS
  if (scrollRef <= 10) {
    scrollRef++;
  } else {
    AOS.refresh();
  }
}

// Add event listeners for resize and scroll
window.addEventListener('resize', handleScrollResize);
window.addEventListener('scroll', handleScrollResize);

  theme.carouselLotties = (function() {
    var defaults = {
      adaptiveHeight: true,
      wrapAround: true,
      prevNextButtons: false
    };
  
    function carouselLotties(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#CarouselLotties-' + sectionId);
      this.namespace = '.lottie-' + sectionId;
  
      if (!this.slideshow) { return }
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
  
    // Carousel Lotties
    carouselLotties.prototype = Object.assign({}, carouselLotties.prototype, {
      init: function() {
        this.flickity = new theme.Slideshow(this.slideshow, defaults);

        const flkty = Flickity.data(this.slideshow);
        // Mousewheel scroll support with gesture debounce
        let wheelAccum = 0;
        let wheelAnimating = false;
        let lastWheelFrame;

        this.slideshow.addEventListener('wheel', (e) => {
          if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
          e.preventDefault();
          if (!flkty || wheelAnimating) return;

          wheelAccum += e.deltaX;

          if (!lastWheelFrame) {
            lastWheelFrame = requestAnimationFrame(() => {
              if (wheelAccum > 20) {
                flkty.next(true, false);
                wheelAnimating = true;
              } else if (wheelAccum < -20) {
                flkty.previous(true, false);
                wheelAnimating = true;
              }

              wheelAccum = 0;
              lastWheelFrame = null;
            });
          }
        }, { passive: false });

        flkty.on('settle', () => {
          wheelAnimating = false;
        });

        flkty.on('select', () => {
          const selectedCell = flkty.selectedElement;

          // Stop all animations
          this.container.querySelectorAll('.lottie-animation').forEach(el => {
            if (el.__lottieInstance) {
              el.__lottieInstance.stop();
            }
          });

          // Play animation in selected cell
          if (selectedCell) {
            const animEl = selectedCell.querySelector('.lottie-animation');
            if (animEl && animEl.__lottieInstance) {
              animEl.__lottieInstance.goToAndPlay(0, true);
            }
          }
        });

        this.container.querySelectorAll('.lottie-animation').forEach(el => {
          fetch(el.dataset.lottieUrl)
            .then(r => r.json())
            .then(animationData => {
              var anim = lottie.loadAnimation({
                container: el,
                renderer: 'svg',
                loop: true,
                autoplay: false,
                animationData
              });
              el.__lottieInstance = anim;
              // After SVG is injected, resize Flickity and play if visible
              anim.addEventListener('DOMLoaded', function() {
                // Ensure Flickity recalculates heights now that the animation SVG is loaded
                var flkty = Flickity.data(this.slideshow);
                if (flkty) {
                  flkty.resize();
                  // If this cell is currently selected, start the animation immediately
                  if (flkty.selectedElement && flkty.selectedElement.contains(el)) {
                    anim.goToAndPlay(0, true);
                  }
                }
              }.bind(this));
            });
        });

        // Create custom page dots (Flickity-style)
        const flktyInstance = Flickity.data(this.slideshow);
        if (flktyInstance && flktyInstance.cells && flktyInstance.cells.length > 0) {
          const dotsContainer = document.createElement('ol');
          dotsContainer.className = 'flickity-page-dots';
          const dots = [];

          const numOriginalSlides = flktyInstance.cells.length / (flktyInstance.options.wrapAround ? 2 : 1);
          for (let i = 0; i < numOriginalSlides; i++) {
            const dot = document.createElement('li');
            dot.className = 'dot';
            dot.setAttribute('data-index', i);
            dot.setAttribute('aria-label', `Page dot ${i + 1}`);
            dots.push(dot);
            dotsContainer.appendChild(dot);
          }

          this.container.appendChild(dotsContainer);

          const updateDots = () => {
            dots.forEach(dot => {
              dot.classList.remove('is-selected');
              dot.removeAttribute('aria-current');
            });
            const index = flktyInstance.selectedIndex % dots.length;
            if (dots[index]) {
              dots[index].classList.add('is-selected');
              dots[index].setAttribute('aria-current', 'step');
            }
          };

          updateDots();
          flktyInstance.on('select', updateDots);

          dotsContainer.addEventListener('click', (e) => {
            if (e.target.matches('.dot')) {
              const index = parseInt(e.target.getAttribute('data-index'), 10);
              if (!isNaN(index)) {
                flktyInstance.select(index);
              }
            }
          });
        }
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      // onDeselect: function() {
      //   if (this.flickity && typeof this.flickity.play === 'function') {
      //     this.flickity.play();
      //   }
      // },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.lotties-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        clearTimeout(this.timeout);
  
        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });
  
    return carouselLotties;
  })(); 

  theme.sections.register('carousel-lotties', theme.carouselLotties);

// Bloggle slider fix for height of .bggle_product-container
function applySlideHeights(slider) {
  if (!slider) return;

  const slides = slider.querySelectorAll('.bggle_product-container');
  if (slides.length === 0) return;

  const sliderHeight = slider.offsetHeight + 1;

  slides.forEach(container => {
    container.style.height = `${sliderHeight}px`;
  });
}

function waitForSliderReady(slider, callback) {
  const checkReady = () => {
    const activeSlide = slider.querySelector('.tns-slide-active');
    if (activeSlide) {
      callback();
    } else {
      setTimeout(checkReady, 50); // keep polling until ready
    }
  };
  checkReady();
}

// Initial run once all sliders are loaded
window.addEventListener('load', () => {
  const sliders = document.querySelectorAll('.bggle--slider');
  sliders.forEach(slider => {
    waitForSliderReady(slider, () => {
      applySlideHeights(slider);
    });
  });
});

// Rerun on resize
window.addEventListener('resize', () => {
  const sliders = document.querySelectorAll('.bggle--slider');
  sliders.forEach(slider => {
    const slides = slider.querySelectorAll('.bggle_product-container');
    slides.forEach(container => {
      container.style.height = '';
    });

    waitForSliderReady(slider, () => {
      applySlideHeights(slider);
    });
  });
});
